const integerFormatter = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });
const moneyFormatter = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const formatInteger = value => integerFormatter.format(Number(value) || 0);

export const formatMoney = value => moneyFormatter.format(Number(value) || 0);
